"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _consts = require("../consts");

var _getTypeToken = _interopRequireDefault(require("./getTypeToken"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getFocus = function getFocus() {
  return (0, _styledComponents.css)([":focus{background:", ";}:focus:not(:focus-visible){background:", ";}:-moz-focusring,:focus-visible{background:", ";}"], (0, _getTypeToken.default)(_consts.TOKENS.backgroundButtonFocus), (0, _getTypeToken.default)(_consts.TOKENS.backgroundButton), (0, _getTypeToken.default)(_consts.TOKENS.backgroundButtonFocus));
};

var _default = getFocus;
exports.default = _default;